import { TooltipProps } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import React, { PropsWithChildren } from 'react';
import { StyledTooltip } from './StyledTooltip';
import { WithMakeStyles } from '@insights-gaming/theme';

interface ProductTourTooltipOwnProps {
  dismissOnClick?: boolean;
  dismissOnEnter?: boolean;
  onClose?: VoidFunction;
  title: React.ComponentType<{ onClose?: VoidFunction }>;
  TooltipClasses?: TooltipProps['classes'];
}

export type ProductTourTooltipProps = PropsWithChildren<ProductTourTooltipOwnProps> & Omit<TooltipProps,  'children' | 'classes' | 'title'> & WithMakeStyles<typeof useStyles>;

const useStyles = makeStyles(createStyles({
  wrapper: {},
}), { name: 'ProductTourTooltip' });

/**
 * Use HOC to bind redux
 */
export function ProductTourTooltip(props: ProductTourTooltipProps) {
  const classes = useStyles(props);
  const {
    children,
    classes: _classes,
    dismissOnClick = true,
    dismissOnEnter = false,
    onClose,
    open,
    title: TitleComponent,
    TooltipClasses,
    ...rest
  } = props;

  return (
    <StyledTooltip
    arrow={true}
    interactive={true}
    open={open}
    classes={TooltipClasses}
    {...rest}
    title={(
      <TitleComponent onClose={onClose} />
    )}
    >
      <span
      onClick={(open && dismissOnClick) ? onClose : undefined}
      onMouseEnter={(open && dismissOnEnter) ? onClose : undefined}
      className={classes.wrapper}
      >
        {children}
      </span>
    </StyledTooltip>
  );
}
